import { render, staticRenderFns } from "./scienceYf.vue?vue&type=template&id=4a681e56&scoped=true&"
import script from "./scienceYf.vue?vue&type=script&lang=js&"
export * from "./scienceYf.vue?vue&type=script&lang=js&"
import style0 from "./scienceYf.vue?vue&type=style&index=0&id=4a681e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a681e56",
  null
  
)

component.options.__file = "scienceYf.vue"
export default component.exports